export default {
      id: "notifications_active-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#notifications_active",
      toString: function () {
        return this.url;
      }
    }